import Axios, { type AxiosInstance } from 'axios'
import { addAxiosCommonInterceptors } from 'client/common-interceptors'

import { isProduction } from 'utils/environment'

let axios: AxiosInstance
const isLocal = process.env.NODE_ENV === 'local'

const configureAxios = () => {
  let baseURL = 'https://stag.justo.cloud/one-stop-checkin-api/'
  if (isProduction()) {
    baseURL = 'https://api.justo.cloud/one-stop-checkin-api/'
  } else if (isLocal) {
    baseURL = 'http://localhost:8080/'
  }

  return Axios.create({ baseURL })
}

const getAxiosInstance = (): AxiosInstance => {
  if (!axios) {
    axios = configureAxios()
    addAxiosCommonInterceptors(axios)
  }

  return axios
}

export const oneStopCheckinAxiosInstance = getAxiosInstance
